import { jwtDecode } from 'jwt-decode';

export const RECRUITER_TOKEN_KEY = 'recruiter_token';

export function getRecruiterToken() {
  try {
    return window.localStorage.getItem(RECRUITER_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setRecruiterToken(token) {
  try {
    if (token) {
      window.localStorage.setItem(RECRUITER_TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(RECRUITER_TOKEN_KEY);
    }
  } catch {
    /* ignore */
  }
}

export function clearRecruiterToken() {
  setRecruiterToken(null);
}

export function decodeRecruiterToken(token = getRecruiterToken()) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
}

export function isRecruiterTokenValid(token = getRecruiterToken()) {
  const payload = decodeRecruiterToken(token);
  if (!payload?.exp) return false;
  return payload.exp * 1000 > Date.now();
}

export function getRecruiterEmail(token = getRecruiterToken()) {
  const payload = decodeRecruiterToken(token);
  return payload?.email ?? payload?.sub ?? null;
}

export const recruiterAuth = {
  get token() {
    return getRecruiterToken();
  },

  get email() {
    return getRecruiterEmail();
  },

  isLoggedIn() {
    return isRecruiterTokenValid();
  },

  setToken: setRecruiterToken,
  clear: clearRecruiterToken,
  decode: decodeRecruiterToken,
};
